export function isInvoiceAddonLine(row) {
  if (!row) return false;
  if (row.is_addon === true || row.is_addon === 1 || row.is_addon === '1') return true;
  return /^Add-on:\s*/i.test(String(row.description || ''));
}

export function invoiceAddonName(row) {
  const named = String(row?.addon_name || '').trim();
  if (named) return named;
  const description = String(row?.description || '')
    .replace(/^Add-on:\s*/i, '')
    .trim();
  const title = description.split(/\s+—\s+/)[0];
  return title || 'Add-on';
}

export function splitInvoiceLines(lineItems) {
  const rows = Array.isArray(lineItems) ? lineItems : [];
  return {
    lines: rows.filter((row) => !isInvoiceAddonLine(row)),
    addons: rows.filter((row) => isInvoiceAddonLine(row)),
  };
}

/** Whole numbers show without decimals (e.g. 1 not 1.00); fractional qty preserved. */
export function formatInvoiceQuantity(q) {
  const n = Number(q);
  if (Number.isNaN(n)) return '—';
  const r = Math.round(n);
  if (Math.abs(n - r) < 1e-9) return String(r);
  return String(n);
}

/**
 * Whether the vendor can send another outbound email on their current plan.
 * Prefers email_allowance from subscription status; falls back to limits/usage.
 */
export function canSendVendorEmail(subscriptionPayload) {
  if (!subscriptionPayload?.has_active_subscription) return false;

  const sub = subscriptionPayload?.current_subscription;
  const allowance = sub?.email_allowance ?? subscriptionPayload?.email_allowance;
  if (allowance && typeof allowance.allowed === 'boolean') {
    return Boolean(allowance.allowed);
  }

  const limits = sub?.limits;
  if (!limits) return false;

  const limit = limits.max_emails_per_month;
  if (limit === 0 || limit === '0') return false;
  if (limit == null) return true;

  const used = Number(sub?.usage?.emails_this_month ?? 0);
  return used < Number(limit);
}

/** @deprecated Use canSendVendorEmail */
export function canForwardInvoiceByEmail(subscriptionPayload) {
  return canSendVendorEmail(subscriptionPayload);
}

export function vendorEmailLimitMessage(subscriptionPayload) {
  const sub = subscriptionPayload?.current_subscription;
  const allowance = sub?.email_allowance ?? subscriptionPayload?.email_allowance;
  if (allowance?.message && allowance.message !== 'OK') {
    return allowance.message;
  }
  if (!subscriptionPayload?.has_active_subscription) {
    return 'You need an active subscription to send emails.';
  }
  return 'Your plan does not allow more emails this month. Upgrade or wait until next month.';
}
